import 'isomorphic-fetch';

import dayjs from 'dayjs';
import { formatPrice } from '@codex/helpers';
import translations, { replacePlaceholders } from '@dc/ui-library/src/config/translations';
import urljoin from 'url-join';
import { loadStoreToken } from '../../../appState/ducks/general';

const formatDiscountLabel = (percentage) => {
  const value = Math.trunc(percentage / 5) * 5; // 0-4 is 0, 5-9 is 5, 10-15 is 10, etc.
  const prefix = percentage !== value ? translations['bundle.discount_prefix'] : '';
  const suffix = translations['bundle.discount_suffix'];

  if (value === 0) {
    return null;
  }

  return `${prefix} ${value}% ${suffix}`;
};

const transformBundles = (bundles) => bundles.map((bundle) => {
  const createdDate = dayjs(bundle.creationDate.replace('+0000', 'Z'));
  const totalSavings = bundle.price && bundle.price.discountAmount
    ? formatPrice(bundle.price.discountAmount, true, bundle.price.currencyCode)
    : null;

  return {
    id: bundle.recommendationType === 'manual'
      ? bundle.id
      : `DS${bundle.data.mainProduct.id}`,
    bundleType: bundle.bundleType,
    recommendationType: bundle.recommendationType,
    createdDate: createdDate.isValid() ? createdDate.format('D MMM YYYY, HH:mm') : '',
    totalPrice: formatPrice(bundle.price.amount, true, bundle.price.currencyCode),
    totalSavings: totalSavings,
    heading: totalSavings
      ? replacePlaceholders(
        translations['bundle.heading_with_saving_price'], { '[PRICE]': totalSavings }
      )
      : translations['bundle.heading'],
    discountLabel: formatDiscountLabel(bundle.price.discountPercentage),
    priceDescription: bundle.data.mainProduct.wasPrice &&
      bundle.data.mainProduct.wasPrice.amount > 0
      ? replacePlaceholders(
        translations['bundle.price_description'],
        {
          '[WAS_PRICE]': formatPrice(
            bundle.data.mainProduct.wasPrice.amount,
            true,
            bundle.price.currencyCode
          ),
          '[PRICE]': bundle.data.mainProduct.price &&
            bundle.data.mainProduct.price.amount > 0
            ? formatPrice(
              bundle.data.mainProduct.price.amount,
              true,
              bundle.price.currencyCode
            ) : NaN,
          '[SEPARATE_PRICE]': bundle.price &&
            bundle.price.separateAmount > 0
            ? formatPrice(
              bundle.price.separateAmount,
              true,
              bundle.price.currencyCode
            ) : NaN
        }
      )
      : '',
    product: {
      ...bundle.data.mainProduct,
      name: `${bundle.data.mainProduct.brandLabel} ${bundle.data.mainProduct.name}`
    },
    addons: bundle.data.subProducts.map((addon) => ({
      ...addon,
      name: `${addon.brandLabel} ${addon.name}`
    }))
  };
});

export const fetchStaticBundles = async (storeApiUrl, bundlesApiPath) => {
  try {
    const token = await window.appState.dispatch(loadStoreToken());
    if (!token) {
      return {
        ok: false,
        error: {
          message: 'Loading token from Store API failed.'
        }
      };
    }

    const gatheringBundlesDataResponse = await fetch(
      urljoin(
        storeApiUrl,
        bundlesApiPath
      )
    );
    if (!gatheringBundlesDataResponse.ok) {
      return {
        ok: false,
        error: {
          message: gatheringBundlesDataResponse.statusText
        }
      };
    }

    const bundlesData = await gatheringBundlesDataResponse.json();

    return {
      ok: true,
      bundlesData: bundlesData.payload && bundlesData.payload.length > 0
        ? transformBundles(bundlesData.payload)
        : []
    };
  } catch (e) {
    return {
      ok: false,
      error: e
    };
  }
};

export const fetchStaticBundleInfo = async (url, action, productId = null) => {
  try {
    const bundleInfoResponse = await fetch(
      url,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: `action=${action}&sAccessoryProductId=${productId ? productId : ''}`
      }
    );

    const bundleInfoResponseJSON = await bundleInfoResponse.json();

    if (bundleInfoResponseJSON.result === 'OK') {
      return {
        ok: true,
        data: bundleInfoResponseJSON.response
      };
    }

    return {
      ok: false,
      error: {
        message: `Error response has come from endpoint: ${url}`
      }
    };
  } catch (e) {
    console.error(e.message);
    console.error(e.stack);

    return {
      ok: false, error: e
    };
  }

};
